import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification-popups-list notification-popups-list--top"
}
const _hoisted_2 = {
  key: 1,
  class: "notification-popups-list notification-popups-list--bottom"
}

import { computed } from "vue";
import NotificationPopup from "./notification-popup.vue";
import NotificationPopupProps from "./notification-popup-props";


export default /*@__PURE__*/_defineComponent({
  __name: 'notification-popups-list',
  props: {
    notifications: {}
  },
  emits: ["destroyPopup"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const topNotifications = computed(() =>
    props.notifications.filter((notification) => !notification.position || notification.position == "top").slice(0, 3)
);

const bottomNotifications = computed(() =>
    props.notifications.filter((notification) => notification.position == "bottom").slice(0, 3)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (topNotifications.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_TransitionGroup, { name: "collapse" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topNotifications.value, (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "notification-popups-list__item",
                  key: notification.id
                }, [
                  _createVNode(NotificationPopup, _mergeProps({ ref_for: true }, notification, {
                    onDestroyPopup: ($event: any) => (emit('destroyPopup', notification.id))
                  }), null, 16, ["onDestroyPopup"])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (bottomNotifications.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_TransitionGroup, { name: "collapse" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottomNotifications.value, (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "notification-popups-list__item",
                  key: notification.id
                }, [
                  _createVNode(NotificationPopup, _mergeProps({ ref_for: true }, notification, {
                    onDestroyPopup: ($event: any) => (emit('destroyPopup', notification.id))
                  }), null, 16, ["onDestroyPopup"])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})